import React, { useContext } from 'react';
import './EledoApi.scss';
import {useShowMenu} from "hooks";
import {useSelector} from "react-redux";
import { AuthContext } from 'AuthContext';

const EledoApi = () => {
  const auth = useContext(AuthContext);
  const templateId = useSelector(state => state.templates.selectedTemplate.id);
  const templateVersion = useSelector(state => state.templates.selectedTemplate.version);
  const schemaModel = useSelector(state => state.templates.selectedTemplate?.derived?.schemaModel)

  const getApiExample = (dataModel) => {
    const example = {
      templateId,
      templateVersion,
      file: {}
    }

    if(dataModel) {
      const fields = dataModel.classes?.find(c => c.classId === dataModel.classId)?.fields

      example.file = dive(dataModel, fields)
    }

    return JSON.stringify(example, null, 4)
  }

  const dive = (dataModel, fields) => {
    const result = {}

    fields?.forEach(field => {
      if(field.relClass) {
        const subclass = dive(dataModel, dataModel.classes?.find(c => c.classId === field.relClass)?.fields)
        if(field.type === 'Array'){
          result[field.id] = [subclass]
        } else {
          result[field.id] = subclass
        }
      } else {
        switch(field.type){
          case 'Boolean':
            result[field.id] = false
            break
          case 'Number':
            result[field.id] = 0
            break
          default:
            result[field.id] = ""
            break
        }
      }
    });

    return result;
  }
  
  useShowMenu();

  return (
    <div className="EledoApi section section-small" data-testid="EledoApi">
      <h3>API Integration</h3>

      <fieldset>
        <label htmlFor="apiKey">
          API Key
        </label>
        <pre id="apiKey">
          {auth.apiToken}
        </pre>
      </fieldset>

      <h3>Example Generate Request</h3>

      <fieldset>
        <label htmlFor="httpRequest">
          HTTP Request
        </label>
        <pre id="httpRequest">
          POST https://eledo.online/api/RESTv1/Generate
        </pre>
      </fieldset>

      <fieldset>
        <label htmlFor="httpRequestHeaders">
          HTTP Request Headers
        </label>
        <pre id="httpRequestHeaders">
{`Content-Type: application/json
Api-Key: ${auth.apiToken}`}
        </pre>
      </fieldset>

      <fieldset>
        <label htmlFor="httpRequestBody">
          HTTP Request Body
        </label>
        <pre id="httpRequestBody">
          {getApiExample(schemaModel)}
        </pre>
      </fieldset>
    </div>
  );
}
export default EledoApi;
